import React, { useEffect } from "react";

export interface DateInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  className?: string;
}

export const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(({ label, className = "", ...props }, ref) => {
  // Add CSS for cyan calendar icons
  useEffect(() => {
    const existingStyle = document.querySelector("#date-input-cyan-styles");
    if (!existingStyle) {
      const style = document.createElement("style");
      style.id = "date-input-cyan-styles";
      style.textContent = `
          .date-input-cyan::-webkit-calendar-picker-indicator {
            filter: invert(68%) sepia(54%) saturate(2180%) hue-rotate(161deg) brightness(91%) contrast(101%);
            cursor: pointer;
          }
        `;
      document.head.appendChild(style);
    }
  }, []);

  const baseClasses =
    "date-input-cyan px-3 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 h-10";

  if (label) {
    return (
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-gray-600 dark:text-gray-400">{label}</label>
        <input
          ref={ref}
          type="date"
          className={`${baseClasses} ${className}`}
          max={new Date().toISOString().split("T")[0]}
          {...props}
        />
      </div>
    );
  }

  return (
    <input
      ref={ref}
      type="date"
      className={`${baseClasses} ${className}`}
      max={new Date().toISOString().split("T")[0]}
      {...props}
    />
  );
});

DateInput.displayName = "DateInput";
